module.exports = __webpack_public_path__ + "assets/img/help_sb3.6ae85abe.png";